import styled from 'styled-components';

export const Container = styled.div`
  .ant-space {
    width: 100%;
    height: 100%;
  }
  .ant-badge {
    height: 100%;
  }
`;
